/**
 * Les lectures de « Préparer mon live » : les lives du jour et du lendemain du masteur
 * (`getTodayTutorLiveOccurrences`), au montage et après chaque mise à jour — comme l'ancien écran.
 *
 * Patron B : la réponse reste ici. La dernière réponse reçue reste à l'écran pendant une relecture
 * (l'ancien écran ne remplaçait sa liste qu'à l'arrivée de la nouvelle) : seul le premier chargement
 * montre le squelette.
 */
import { useState } from "react"
import { useSelector } from "react-redux"

import { liveService } from "../../../../../../data/services/liveService"
import { type ApiPrepareOccurrence } from "../../../../adapters/tutor/Lives/tutorPrepareLiveAdapter"
import { selectAccount } from "../../../../view-models/shared/displayedStudent"
import { useApiFetch } from "../../../hooks/useApiFetch"

export function useTutorPrepareLiveData() {
    const tutorId = useSelector(
        (state: unknown) => (selectAccount(state as never) as { id?: string | number } | null)?.id
    )
    const [shown, setShown] = useState<ApiPrepareOccurrence[] | null>(null)
    const occurrences = useApiFetch<ApiPrepareOccurrence[]>({
        service: liveService.getTodayTutorLiveOccurrences,
        routeParams: { id: tutorId },
        requestKey: tutorId != null ? String(tutorId) : null,
        enabled: tutorId != null,
        onSuccess: (data) => setShown(data ?? []),
    })
    return {
        raw: shown,
        loading: shown == null && occurrences.error == null,
        error: shown == null ? occurrences.error : null,
        refetch: occurrences.fetch,
    }
}
